<div class="grid ">
	<div class="col-12">
		<div class="card" *ngIf="!permissaoInserir">
			<div style="text-align: center;">
				<h4>Você não possui permissão de acesso essa página!</h4>
			</div>
		</div>
		<div class="card" *ngIf="permissaoInserir">
			<form #f="ngForm" name="form" novalidate>
				<div class="formgroup">
					<div class="p-fluid p-formgrid grid">
						<div *ngIf="messagemVisivel" class="field col-12 md:col-12">
							<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
						</div>
						<div class="field col-12 md:col-3">
							<label htmlFor="data">Data da Saída</label>
							<p-calendar [showIcon]="true" [showOnFocus]="false" dateFormat="dd/mm/yy"
								[showButtonBar]="true" name="data" ngModel #data="ngModel" [required]="true"
								[(ngModel)]="dataSelecionada" placeholder="Selecione" (onSelect)="carregarComandas()">
							</p-calendar>
						</div>
						<div class="field col-12 md:col-3" *ngIf="dataSelecionada">
							<ng-container *ngIf="exibirSpinnerComanda; else exibeComanda">
								<p-progressSpinner 
								  class="flex mt-5" 
								  [style]="{width: '50px', height: '50px'}" 
								  styleClass="custom-spinner" 
								  strokeWidth="8" 
								  fill="var(--surface-ground)" 
								  animationDuration=".5s">
								</p-progressSpinner>
							  </ng-container>
							
							  <ng-template #exibeComanda>
								<label>Comanda</label>
								<p-dropdown 
								  [options]="listaComandas" 
								  optionLabel="cliente.apelido" 
								  [filter]="true"
								  emptyFilterMessage="Nenhum registro" 
								  placeholder="Selecione" 
								  name="comanda" 
								  ngModel
								  #comanda="ngModel" 
								  [(ngModel)]="comandaSelecionada" 
								  (onChange)="carregarSaidasEstoque()">
								</p-dropdown>
							  </ng-template>
						</div>
						<div class="field col-12 md:col-4" *ngIf="comandaSelecionada">
							<ng-container *ngIf="exibirSpinnerServico; else exibeSelecionarServico">
								<p-progressSpinner
								  class="flex mt-5" 
								  [style]="{width: '50px', height: '50px'}" 
								  styleClass="custom-spinner" 
								  strokeWidth="8" 
								  fill="var(--surface-ground)" 
								  animationDuration=".5s">
								</p-progressSpinner>
							  </ng-container>
							
							  <ng-template #exibeSelecionarServico>
								  <label>Escolha o Serviço</label>
								  <p-dropdown [options]="servicosComanda" optionLabel="descricaoItem"
									  emptyFilterMessage="Nenhum registro" placeholder="Selecione" name="servico" ngModel
									  #servico="ngModel" [(ngModel)]="servicoSelecionado" (onChange)="selecionarServico()">
								  </p-dropdown>
							  </ng-template>
						</div>
						<br>
						<div class="field col-12 md:col-2" *ngIf="servicoSelecionado">
							<button pButton pRipple label="Adicionar Produto" class="p-button-primary mt-5 -mr-5"
								icon="pi pi-shopping-cart" style="box-shadow: none;" type="button"
								(click)="abrirDialogAdicionarProduto()">
							</button>
						</div>
						<div class="field col-12 md:col-12">
							<p-divider></p-divider>
						</div>



					</div>
					<div class="p-fluid p-formgrid grid" *ngIf="itemProdutoSelecionado">
						<div class="field col-12 md:col-4">
							<label htmlFor="quantidadeItemSelecionado">Descrição</label>
							<label for="" class="form-control">{{itemProdutoSelecionado.descricao}}</label>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="quantidadeItemSelecionado">Estoque</label>
							<label for="" class="form-control">{{ itemProdutoSelecionado.estoqueAtual }} {{
								itemProdutoSelecionado.descricaoUnidadeMedida }}</label>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="qtdItemSelecionado">Quantidade</label>
							<input pInputText type="number" name="quantidadeProdutoSelecionada" #qtdItemSelecionado="ngModel"
								[(ngModel)]="quantidadeProdutoSelecionado" required>
							<div *ngIf="qtdItemSelecionado.touched && (quantidadeProdutoSelecionado == null || quantidadeProdutoSelecionado <= 0)" class="alerta">
									<small>Insira a quantidade</small>
							</div>
						</div>
						<div class="field col-12 md:col-2">
							<label htmlFor="profSelecionado">Profissional</label>
							<p-dropdown [options]="listaProfissionais" optionLabel="nomeProfissional" [filter]="true"
								emptyFilterMessage="Nenhum registro" name="profSelecionado" ngModel
								#profSelecionado="ngModel" emptyMessage="Nenhum registro"
								placeholder="Nenhum selecionado" [(ngModel)]="profissionalSelecionado">
							</p-dropdown>
						</div>
						<div class="field col-12 md:col-2">
							<div class="p-fluid">
								<button type="button" pButton icon="pi pi-check" class="p-button-success mt-5 mr-1"
									pTooltip="Adicionar" (click)="salvarSaida()" [disabled]="quantidadeProdutoSelecionado && quantidadeProdutoSelecionado <= 0"></button>
								<button type="button" pButton icon="pi pi-times" class="p-button-danger mt-5"
									pTooltip="Cancelar" (click)="removerItemSelecionado()"></button>
							</div>
						</div>
					</div>
					<div class="mb-5">
						<p-table #tabelaItens [value]="listaItensSaidaEstoque" dataKey="id" [rows]="10" [rowHover]="true"
							[paginator]="false" responsiveLayout="scroll" styleClass=" p-datatable-sm" [loading]="loadingTableItens">
							<ng-template pTemplate="header">
								<tr>
									<th>Descrição</th>
									<th>Quantidade</th>
									<th>Profisssional</th>
									<th>Ações</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-item let-i="rowIndex">
								<tr>

									<td>
										<label>{{ item.descricaoItem }}</label>
									</td>
									<td>
										<label>{{ item.quantidade }}</label>
									</td>
									<td>
										<label>{{ item.nomeProfissional }}</label>
									</td>

									<td>
										<button pButton pRipple pTooltip="Excluir" type="button" icon="pi pi-trash"
											class="p-button-danger" (click)="excluirSaida(item)">
										</button>
									</td>
								</tr>

							</ng-template>
							<ng-template pTemplate="summary">
								<div class="flex align-items-center justify-content-start">
									<div>
										Há {{listaItensSaidaEstoque ? listaItensSaidaEstoque.length : 0 }} itens
										inseridos
									</div>
									<!-- <div class="flex-column hidden md:flex" *ngIf="listaItensSaida.length > 0">
										<span class="text-right">Total: </span>
									</div> -->
								</div>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="7">Nenhum item adicionado.</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="loadingbody">
								<tr>
									<td colspan="7">Carregando. Por favor aguarde.</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
					<div class="p-fluid p-formgrid grid justify-content-end">
						<!-- <div class="field col-12 md:col-2" *ngIf="!progressoRequisicao">
							<button type="button" pButton icon="pi pi-check" label="Salvar" (click)="salvar()"
								class="p-button-success mt-5"></button>
						</div>
						<div class="field col-12 md:col-2" *ngIf="progressoRequisicao">
							<button type="button" pButton icon="pi pi-spin pi-spinner" label="Salvando..."
								class="p-button-success mt-5" [disabled]="true"></button>
						</div> -->
						<div class="field col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem" routerLink="/apps/saida-estoque"></button>
						</div>
					</div>
				</div>
			</form>
			<p-dialog header="Escolher Produto" [(visible)]="exibirDialogProduto" [modal]="true" [draggable]="false"
				[resizable]="false" [closable]="true">
				<div class="card">
					<div class="flex justify-content-center" *ngIf="exibirSpinnerDialog">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<p-table #tbItensDialog [value]="listaProdutosDialog" dataKey="id"
						[rows]="itensProdutosPaginados ? itensProdutosPaginados.size : 0" [loading]="loadingTableItens"
						[rowHover]="true" [paginator]="true" (onPage)="onPageChangeProdutos($event)"
						[totalRecords]="itensProdutosPaginados ? itensProdutosPaginados.totalElements : 0" [lazy]="true"
						[showCurrentPageReport]="true" responsiveLayout="scroll" styleClass=" p-datatable-sm"
						currentPageReportTemplate="Mostrando {first} ao {last} de {totalRecords} registros"
						*ngIf="!exibirSpinnerDialog">
						<ng-template pTemplate="caption">
							<div class="flex justify-content-end flex-column sm:flex-row">
								<span class="p-input-icon-left">
									<i class="pi pi-search"></i>
									<input pInputText type="text" #filter (input)="buscarDialogItens($event)"
										placeholder="Buscar" class="w-full" />
								</span>
								<span class="ml-2">
									<button pButton class="p-button-outlined" icon="pi pi-filter-slash"
										pTooltip="Limpar Filtros" (click)="limparDialogItens()"></button>
								</span>
							</div>
						</ng-template>
						<ng-template pTemplate="header">
							<tr>
								<th pSortableColumn="codigo">
									<div>
										Código
									</div>
								</th>
								<th pSortableColumn="descricao">
									<div>
										Descrição
									</div>
								</th>
								<th>
									<div>
										Estoque atual
									</div>
								</th>

								<th style="text-align: center;">
									<div>
										Selecionar
									</div>
								</th>
							</tr>
						</ng-template>
						<ng-template pTemplate="body" let-item let-i="rowIndex">
							<tr>
								<td>
									<label>{{ item.codigo }}</label>
								</td>
								<td>
									<label>{{ item.descricao }}</label>
								</td>
								<td>
									<label>{{ item.estoqueAtual }} {{ item.descricaoUnidadeMedida }}</label>
								</td>

								<td style="text-align: center;">
									<button pButton pRipple pTooltip="Adicionar" type="button" icon="pi pi-check"
										class="p-button-success" (click)="selecionarItem(item)">
									</button>
								</td>
							</tr>
						</ng-template>
					</p-table>

				</div>
				<p-footer>
					<button type="button" pButton icon="pi pi-times" label="Cancelar" class="p-button-danger mt-2"
						(click)="fecharDialogAdicionarProduto()"></button>
				</p-footer>
			</p-dialog>
			<p-confirmDialog [style]="{width: '50vw'}"></p-confirmDialog>
		</div>
	</div>
</div>